import React from "react";

// components
import { Filter } from "../../../components/FilterChips/FilterChips";
import { TODO_STATUS_OPTIONS, TodosFilters } from "./TodosFilterPanel";

import ReadableFilterChipsShell from "../ReadableFilterChipsShell";
import { describeDateRange } from "../dateFormatting";

export const convertTodosFiltersToReadableList = (filters: Partial<TodosFilters>): Filter[] => {
	const readableList: Filter[] = [];

	if (filters.assignee) {
		readableList.push({
			id: "assignee",
			type: "single-employee",
			label: "Assignee",
			value: { id: filters.assignee.id, name: filters.assignee.name },
		});
	}

	if (filters.workflow) {
		readableList.push({
			id: "workflow",
			type: "string",
			label: "Workflow",
			value: filters.workflow.name,
		});
	}

	if (filters.actor) {
		readableList.push({
			id: "actor",
			type: "single-employee",
			label: "Actor",
			value: { id: filters.actor.id, name: filters.actor.name },
		});
	}

	if (filters.status) {
		readableList.push({
			id: "status",
			type: "string",
			label: "Status",
			value: TODO_STATUS_OPTIONS.find((option) => option.value === filters.status)?.label ?? filters.status,
		});
	}

	if (filters.dueDateStart || filters.dueDateEnd) {
		readableList.push({
			id: "dueDate",
			type: "string",
			label: "Due Date",
			value: describeDateRange(filters.dueDateStart, filters.dueDateEnd),
		});
	}

	if (filters.completedDateStart || filters.completedDateEnd) {
		readableList.push({
			id: "completedDate",
			type: "string",
			label: "Completed Date",
			value: describeDateRange(filters.completedDateStart, filters.completedDateEnd),
		});
	}

	return readableList;
};

const CHIP_ID_TO_FILTER_KEYS: Record<string, (keyof TodosFilters)[]> = {
	dueDate: ["dueDateStart", "dueDateEnd"],
	completedDate: ["completedDateStart", "completedDateEnd"],
};

type ReadableTodosFilterChipsProps = {
	filters: Partial<TodosFilters>;
	setFilters: (newFilters: Partial<TodosFilters>) => void;
};

const ReadableTodosFilterChips = ({ filters, setFilters }: ReadableTodosFilterChipsProps) => (
	<ReadableFilterChipsShell<TodosFilters>
		filters={filters}
		setFilters={setFilters}
		convert={convertTodosFiltersToReadableList}
		chipIdToFilterKeys={CHIP_ID_TO_FILTER_KEYS}
	/>
);

export default ReadableTodosFilterChips;
